var $fe732cdb32124ea8$exports = {};
$fe732cdb32124ea8$exports = {
  "deselectedItem": function deselectedItem(args) {
    return "".concat(args.item, " \u05DC\u05D0 \u05E0\u05D1\u05D7\u05E8.");
  },
  "longPressToSelect": "\u05D4\u05E7\u05E9\u05D4 \u05D0\u05E8\u05D5\u05DB\u05D4 \u05DC\u05DB\u05E0\u05D9\u05E1\u05D4 \u05DC\u05DE\u05E6\u05D1 \u05D1\u05D7\u05D9\u05E8\u05D4.",
  "select": "\u05D1\u05D7\u05E8",
  "selectedAll": "\u05DB\u05DC \u05D4\u05E4\u05E8\u05D9\u05D8\u05D9\u05DD \u05E0\u05D1\u05D7\u05E8\u05D5.",
  "selectedCount": function selectedCount(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      "=0": "\u05DC\u05D0 \u05E0\u05D1\u05D7\u05E8\u05D5 \u05E4\u05E8\u05D9\u05D8\u05D9\u05DD",
      one: function one() {
        return "\u05E4\u05E8\u05D9\u05D8 ".concat(formatter.number(args.count), " \u05E0\u05D1\u05D7\u05E8");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " \u05E4\u05E8\u05D9\u05D8\u05D9\u05DD \u05E0\u05D1\u05D7\u05E8\u05D5");
      }
    }), ".");
  },
  "selectedItem": function selectedItem(args) {
    return "".concat(args.item, " \u05E0\u05D1\u05D7\u05E8.");
  }
};
export { $fe732cdb32124ea8$exports as default };